import { CurrentUser } from '@/server/MakeSenseApp-backend'
import { use } from 'echarts'
import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore('userStore', () => {
  const isMasterAdmin = ref<boolean>(false)
  const isAdmin = ref<boolean>(false)
  const isAdminOrHigher = ref<boolean>(false)
  const isOwner = ref<boolean>(false)
  const isOwnerOrHigher = ref<boolean>(false)

  const hasNoRoles = ref<boolean>(false)

  const refreshDataCounter = ref<number>(0)

  const currentUser = ref<CurrentUser | null>(null)

  function refreshData() {
    refreshDataCounter.value = refreshDataCounter.value + 1
  }

  function setCurrentUser(user: CurrentUser) {
    isMasterAdmin.value = user.roles?.some((x) => x == 'MasterAdmin') ?? false
    isAdmin.value = user.roles?.some((x) => x == 'Admin') ?? false
    isOwner.value = user.roles?.some((x) => x == 'Owner') ?? false

    hasNoRoles.value = user.roles?.length == 0

    isAdminOrHigher.value = isAdmin.value || isMasterAdmin.value
    isOwnerOrHigher.value = isOwner.value || isAdmin.value || isMasterAdmin.value
    currentUser.value = user
  }

  return {
    isAdmin,
    isOwner,
    isMasterAdmin,
    isAdminOrHigher,
    isOwnerOrHigher,
    hasNoRoles,
    currentUser,
    refreshDataCounter,
    setCurrentUser,
    refreshData
  }
})
